import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign, non-actionable errors injected by the browser / extensions
// (e.g. the WebKit password-autofill bug "autofillFieldData.autoCompleteType"),
// so they don't surface as app-level crashes. Real app errors still propagate.
if (typeof window !== "undefined") {
  const isBenignBrowserError = (reason) => {
    const msg = String((reason && (reason.message || reason.reason)) ?? reason ?? "");
    const stack = String((reason && reason.stack) || "");
    return (
      msg.includes("autoCompleteType") ||
      msg.includes("autofillFieldData") ||
      msg === "Script error." ||
      msg.includes("ResizeObserver loop") ||
      stack.includes("webkit-masked-url") ||
      stack.includes("extensions::") ||
      stack.includes("chrome-extension://") ||
      stack.includes("safari-extension://")
    );
  };
  const handler = (e) => {
    const reason = e && (e.reason !== undefined ? e.reason : (e.error || e.message));
    if (isBenignBrowserError(reason)) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return false;
    }
  };
  window.addEventListener("unhandledrejection", handler, true);
  window.addEventListener("error", handler, true);
}

if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(() => {}); });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
